var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottomNavigation = void 0;
var BottomNavigation_1 = __importDefault(require("./BottomNavigation"));
exports.BottomNavigation = BottomNavigation_1.default;
exports.default = BottomNavigation_1.default;
//# sourceMappingURL=index.js.map